// QK
const QK_C1_TABLE = [
  { qkBase: 10, count: 5 },
  { qkBase: 11, count: 7 },
  { qkBase: 12, count: 9 },
  { qkBase: 13, count: 11 },
  { qkBase: 14, count: 13 },
  { qkBase: 15, count: 15 },
  { qkBase: 16, count: 17 },
  { qkBase: 17, count: 19 },
  { qkBase: 18, count: 21 },
  { qkBase: 19, count: 23 },
  { qkBase: 20, count: 25 },
  { qkBase: 21, count: 27 },
  { qkBase: 22, count: 29 },
  { qkBase: 23, count: 31 },
  { qkBase: 24, count: 33 },
  { qkBase: 25, count: 35 },
  { qkBase: 26, count: 37 },
  { qkBase: 27, count: 39 },
  { qkBase: 28, count: 41 },
  { qkBase: 29, count: 45 },
  { qkBase: 30, count: 49 },
  { qkBase: 31, count: 53 },
  { qkBase: 32, count: 57 },
  { qkBase: 33, count: 61 },
  { qkBase: 34, count: 65 },
  { qkBase: 35, count: 69 },
  { qkBase: 36, count: 73 },
  { qkBase: 37, count: 77 },
  { qkBase: 38, count: 81 },
  { qkBase: 39, count: 85 },
  { qkBase: 40, count: 89 },
  { qkBase: 41, count: 93 },
  { qkBase: 42, count: 97 },
  { qkBase: 43, count: 101 },
  { qkBase: 44, count: 105 },
  { qkBase: 45, count: 113 },
  { qkBase: 46, count: 121 },
  { qkBase: 47, count: 129 },
  { qkBase: 48, count: 137 },
  { qkBase: 49, count: 145 },
  { qkBase: 50, count: 153 },
  { qkBase: 51, count: 161 },
  { qkBase: 52, count: 169 },
  { qkBase: 53, count: 177 },
  { qkBase: 54, count: 185 },
  { qkBase: 55, count: 193 },
  { qkBase: 56, count: 201 },
  { qkBase: 57, count: 209 },
  { qkBase: 58, count: 217 },
  { qkBase: 59, count: 233 },
  { qkBase: 60, count: 249 },
  { qkBase: 61, count: 265 },
  { qkBase: 62, count: 281 },
  { qkBase: 63, count: 297 },
  { qkBase: 64, count: 313 },
  { qkBase: 65, count: 329 },
  { qkBase: 66, count: 345 },
  { qkBase: 67, count: 361 },
  { qkBase: 68, count: 377 },
  { qkBase: 69, count: 393 },
  { qkBase: 70, count: 409 },
  { qkBase: 71, count: 425 },
  { qkBase: 72, count: 441 },
  { qkBase: 73, count: 457 },
  { qkBase: 74, count: 473 },
  { qkBase: 75, count: 489 },
  { qkBase: 76, count: 505 },
  { qkBase: 77, count: 521 },
  { qkBase: 78, count: 537 },
  { qkBase: 79, count: 553 },
  { qkBase: 80, count: 569 },
  { qkBase: 81, count: 585 },
  { qkBase: 82, count: 601 },
  { qkBase: 83, count: 617 },
  { qkBase: 84, count: 633 },
  { qkBase: 85, count: 649 },
  { qkBase: 86, count: 665 },
  { qkBase: 87, count: 681 },
  { qkBase: 88, count: 697 },
  { qkBase: 89, count: 713 },
  { qkBase: 90, count: 729 },
  { qkBase: 91, count: 745 },
  { qkBase: 92, count: 761 },
  { qkBase: 93, count: 777 },
  { qkBase: 94, count: 793 },
  { qkBase: 95, count: 809 },
  { qkBase: 96, count: 825 },
  { qkBase: 97, count: 841 },
  { qkBase: 98, count: 857 },
  { qkBase: 99, count: 873 },
  { qkBase: 100, count: 889 },
  { qkBase: 101, count: 905 },
  { qkBase: 102, count: 921 },
  { qkBase: 103, count: 937 },
  { qkBase: 104, count: 953 },
  { qkBase: 105, count: 969 },
  { qkBase: 106, count: 985 },
  { qkBase: 107, count: 1001 },
  { qkBase: 108, count: 1017 },
  { qkBase: 109, count: 1033 },
  { qkBase: 110, count: 1049 },
  { qkBase: 111, count: 1065 },
  { qkBase: 112, count: 1081 },
  { qkBase: 113, count: 1097 },
  { qkBase: 114, count: 1113 },
  { qkBase: 115, count: 1129 },
  { qkBase: 116, count: 1145 },
  { qkBase: 117, count: 1161 },
  { qkBase: 118, count: 1177 },
  { qkBase: 119, count: 1497 },
  { qkBase: 120, count: 9999 }
];

function QkC1Base(c1Count) {
  const qkC1Row = QK_C1_TABLE.find(row => row.count >= c1Count);
  if (qkC1Row) {
    return qkC1Row.qkBase;
  } else {
    console.error("Unable to calculate valid QK value");
    return QK_C1_TABLE[QK_C1_TABLE.length - 1].qkBase;
  }
}

function calcQk(findingStatistic) {
  const QK_BASE_A = QK_C1_TABLE[6].qkBase;
  const FAKTOR_A = 3;

  const QK_BASE_B = QK_C1_TABLE[2].qkBase;
  const FAKTOR_B = 1;

  const sumA = findingStatistic.A + findingStatistic.A1;
  const sumB = findingStatistic.B + findingStatistic.B1;
  const sumC1 = findingStatistic.C1;

  const qkBase = QkC1Base(sumC1);

  /*
  
  Benutze die Werte um Faktor 10 Größer um Rundungsfehler beim berechnen zu verhindern.
  a = 1.6 + 3 * 0.1 + 0*0.3
  1.9000000000000001
  b = ( 16 + 3 * 1 + 0 * 3 ) / 10
  1.9
  a === b
  false

*/
  const qkResult = qkBase + sumB * FAKTOR_B + sumA * FAKTOR_A;

  return qkResult / 10;
}

function testQK(expected, findingStatistic) {
  const result = calcQk(findingStatistic);
  console.assert(
    result === expected,
    `QK Failed: expect ${expected} got ${result} - ${JSON.stringify(
      findingStatistic,
      undefined,
      2
    )}`
  );
}

export function CalcQkResult(getAuditFindingsFlat) {
  testQK(1.6, {
    A1: 0,
    A: 0,
    B1: 0,
    B: 1,
    C1: 14,
    C: 20
  });
  testQK(1.9, {
    A1: 0,
    A: 0,
    B1: 0,
    B: 3,
    C1: 16,
    C: 27
  });
  testQK(1.3, {
    A1: 1,
    A: 0,
    B1: 0,
    B: 0,
    C1: 5,
    C: 0
  });

  const findingStatistic = {
    A1: 0,
    A: 0,
    B1: 0,
    B: 0,
    C1: 0,
    C: 0
  };
  let pkt = 0;
  let count = 0;
  getAuditFindingsFlat.forEach(findingFlat => {
    if (typeof findingStatistic[findingFlat.findingTypeAbbr] === "number") {
      findingStatistic[findingFlat.findingTypeAbbr]++;
      pkt += findingFlat.findingWeight;
      count++;
    }
  });
  const qk = calcQk(findingStatistic);

  return { qk, pkt, count };
}

/*


    const getQKBase = c1 => {
      // TODO: Aus Config laden
      let qk_pts_base = 400;
      let qk_base = 1.0;
      let qk_pts_intval = 20;

      const ranges = [
        { min: 5, max: 41, base_value: 400, base_qk: 1.0, interval: 2 },
        { min: 41, max: 105, base_value: 1120, base_qk: 2.8, interval: 4 },
        { min: 105, max: 217, base_value: 2360, base_qk: 4.4, interval: 8 },
        { min: 217, max: 1177, base_value: 2360, base_qk: 4.4, interval: 16 }
        // TBC
      ];

      let qk = qk_base;
      let qk_pts = qk_pts_base;

      // TODO: Intervalle berücksichtigen
      for (let i in ranges) {
        if (c1 >= ranges[i].max) {
          qk =
            qk + ((ranges[i].max - ranges[i].min) * 0.1) / ranges[i].interval;
          qk_pts = qk_pts + (ranges[i].max - ranges[i].min) * qk_pts_intval;
        } else if (ranges[i].max > c1 && c1 > ranges[i].min) {
          qk = qk + Math.ceil((c1 - ranges[i].min) / ranges[i].interval) * 0.1;
          qk_pts =
            qk_pts +
            Math.ceil((c1 - ranges[i].min) / ranges[i].interval) *
              ranges[i].interval *
              qk_pts_intval;
        } else {
          console.log("Nicht erreicht");
        }
      }

      console.log("C1", c1, "BASE QK", qk, "BASE QK-PTS", qk_pts);
      return qk;
    };

    const findingSumByCategory = {
      a: 0,
      a1: 0,
      b1: 0,
      b: 1,
      c1: 14,
      c: 20
    };

    let result =
      getQKBase(findingSumByCategory["c1"]) +
      findingSumByCategory["b"] * 0.1 +
      findingSumByCategory["b1"] * 0.1 +
      findingSumByCategory["a"] * 0.3 +
      findingSumByCategory["a1"] * 0.3;

    if (
      findingSumByCategory["b"] + findingSumByCategory["b1"] > 0 &&
      result < 1.2
    ) {
      result = 1.2;
    }

    if (
      findingSumByCategory["a"] + findingSumByCategory["a1"] > 0 &&
      result < 1.6
    ) {
      result = 1.6;
    }*/

//  Object.entries(reportData.findings.reduce((prev,finding)=>{if(finding.customFieldsCostcenter in prev){prev[finding.customFieldsCostcenter].push(finding);}else{prev[finding.customFieldsCostcenter]=[finding];}return prev;},{})).map(([costcenterId,groupedFindings])=>{const init=()=>({c:0,p:0});if(!reportData.summeryListTotal){reportData.summeryListTotal={total:init(),A:init(),A1:init(),B:init(),B1:init(),C:init(),C1:init()};}const res={costcenterId,total:init(),A:init(),A1:init(),B:init(),B1:init(),C:init(),C1:init()};groupedFindings.forEach(finding=>{if(finding.findingTypeAbbr in res){res[finding.findingTypeAbbr].c++;res[finding.findingTypeAbbr].p+=finding.findingWeight;reportData.summeryListTotal[finding.findingTypeAbbr].c++;reportData.summeryListTotal[finding.findingTypeAbbr].p+=finding.findingWeight;res.total.c++;res.total.p+=finding.findingWeight;reportData.summeryListTotal.total.c++;reportData.summeryListTotal.total.p+=finding.findingWeight;}});return res;})" :key="i">
